import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<div style="text-align: justify;">
			<p class="mb-3">
				Maje 2024 en eldonejo “Dokumenta Esperanto-centro” en Durdevac aperis unua beletra libro de Tatjana Auderskaja. 
				Ŝi havis jam tri eldonitajn librojn, sed ĉiuj ili estas… hmmm, kiel diri? 
				Scienc-popularigaj? 
				Specialaj? 
				Nu, almenaŭ ne pure beletraj.
			</p>
			
			<p class="mb-3">
				Sed jen – frukto de multjara laboro, malgrandformata libreto de 160 paĝoj kun 60 verkoj. 
				La libro, eldonita de kroata eldonejo, aspektas lukse: malmola kovrilo, blanka papero, bela literaro… 
				Ne multaj Esperanto-eldonejoj en la mondo kapablas eldoni tiel altnivele.
			</p>
			
			<p class="mb-3">
				Sed kio pri la enhavo?
			</p>
			
			<p class="mb-3">
				Videblas, ke la aŭtoro ne ŝatas longajn paroladojn: la plej ampleksa prozaĵo “Rakonto de Momo” okupas eĉ 8 paĝojn! 
				Abundas en la libro tre malgrandaj rakontoj, kaj ofte ne eblas fari dividon inter veraj rakontoj kaj mikronoveloj, 
				kiuj tamen konsistigas apartan ĉapitron. Sed ĉiu ero, granda aŭ malgranda, enhavas sian ideon, iun penson, kio estas rara afero… 
				Tial, la libro, eble, ne estas facila legaĵo por tiuj, kiuj serĉas kutiman kaj agrablan enhavon. 
				Unu ĉapitro de la libro nomiĝas “Fantasto”; sed fakte, neniu verko tie estas realisma, 
				nenie la aŭtoro diligente ion priskribas aŭ skrupule klarigas. 
				Ŝi nur donas ideon, imagon, kiun oni povas kompreni, disvolvi – aŭ ne kompreni kaj forĵeti, se oni ne aprezas tian stilon. 
			</p>
			
			<p class="mb-3">
				El la du teatraĵoj, ambaŭ estas nur ŝercoj. “Ama kvadrato” – ironia enhave kaj stile parodio, primokanta primitive-patosajn verkojn, 
				kiuj aperadis en aŭroro de nia literaturo, sed povas aperi eĉ nun, kun la nova ondo de zelotoj… 
				Fakte, tiu verketo estis planita por teatro de marionetoj, lignaj pupetoj kun mekanikaj movoj kaj same mekanikaj paroloj. 
				La aŭtoro eĉ trovis pupteatron, kiu pretis surscenigi ĝin. Sed venis grandaj ŝanĝoj en la vivo… 
				Kaj “Rok-opero” estas simple bon-humora kaj -humura skizo pri junulara ekologia tendaro.
			</p>
			
			<p class="mb-3">
				Kvankam la prozaj verkoj estas dividitaj en tri diversaj ĉapitroj: “Fantasto”, “Rakontoj” kaj “Mikronoveloj”, 
				fakte ili kunfluas en unu sufiĉe homogena amaso, kunigita per kelkaj komunaj trajtoj: koncizemo; ironio; strebo ekvidi la sencon, 
				enon de aferoj, sed ne ilian supraĵon; kredo al Naturo; sento de Historio.
			</p>
			
			<p class="mb-3">
				Kontraste, en ĉapitro “Poemoj” estas kolektitaj eroj de diversaj stiloj kaj ĝenroj, aperintaj dum grandega tempa intervalo, de 1985 ĝis 2025. 
				Videblas, ke por la aŭtoro ne poezio, sed prozo estas grava. 
				La poemojn ŝi verkas, kiam la ideo insiste postulas tre firman formon por esti esprimita. Aŭ kiam intima sento estas tro forta. 
				Aŭ simple por ĝui propran majstrecon ludi per rimoj, kiel en serioj de parodioj “Griza kapreto” kaj Limerikoj. Kaj diference de la prozo, 
				kie kutime regas malvarma ironio, en poezio jen-jen ekflagras bruliga sento. 
				Ne nepre amo.
			</p>
			
			<p class="mb-3">
				Do, la libro vere nekutima. Ne facile digestebla. 
				Nokte ni vojaĝas tra ĝi. Kaj la lumo devas aperi interne. 
			</p>
		</div>
		`
	)
}

const itemName = {
	esp: 'Provo de recenzo'
}

const itemDate = {
	esp: `13an de marto 2025`
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemDate: itemDate.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
	}
}

export default item;

